export default "__VITE_ASSET__D1p_TiCz__"